import { useState } from 'react';
import { EngravingCanvas } from './EngravingCanvas';
import { glassShapeOf } from './GlassLook';
import { Glass3DView } from './glass3d/Glass3DPanel';
import { ZoomPan } from './ZoomPan';

// Final preview: zoomable photo view; glass articles can switch to the rotatable 3D model.
export const PreviewStage = ({ editor }) => {
  const glass = glassShapeOf(editor.product), [mode, setMode] = useState('photo');
  return <div className="preview-stage" data-testid="preview-stage">
    {glass && <div className="preview-mode" role="tablist" aria-label="Ansicht">{[['photo', 'Foto'], ['3d', '3D']].map(([id, label]) => <button key={id} type="button" role="tab" aria-selected={mode === id} className={mode === id ? 'on' : ''} onClick={() => setMode(id)} data-testid={`preview-mode-${id}`}>{label}</button>)}</div>}
    {mode === '3d' && glass ? <Glass3DView product={editor.product} editor={editor} testid="preview-3d" /> : <ZoomPan><EngravingCanvas editor={editor} preview /></ZoomPan>}
  </div>;
};
